// extracted by mini-css-extract-plugin
module.exports = {"agreement":"da51a739f7--agreement--pfIXj","label":"da51a739f7--label--ifhXo","link":"da51a739f7--link--CMTwJ"};